import { render } from "./FilesList.vue?vue&type=template&id=7a236aae&scoped=true"
import script from "./FilesList.vue?vue&type=script&lang=ts"
export * from "./FilesList.vue?vue&type=script&lang=ts"

import "./FilesList.vue?vue&type=style&index=0&id=7a236aae&lang=scss&scoped=true"
import "./FilesList.vue?vue&type=style&index=1&id=7a236aae&lang=scss"
script.render = render
script.__scopeId = "data-v-7a236aae"

export default script